import type { OfferApi } from '@fourthwall/services/dist/OffersApiClient'

export const filterOffersWithVariants = (offers: OfferApi.GetOffersResponse['offers']) =>
  offers
    .map((offer) => ({
      ...offer,
      variants: offer.variants.filter((variant) => variant.status !== 'UNAVAILABLE'),
    }))
    .filter((offer) => offer.variants.length > 0)
